function getMessageEnabled(phonesOrEmails = []) {
  return phonesOrEmails.reduce((acc, curr = {}) => (
    (curr.acceptable_communication_types || []).includes('message') ?
      [...acc, curr] :
      acc
  ), []);
}

export default getMessageEnabled;
